var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-button",
    {
      class: _vm.className,
      attrs: {
        disabled: _vm.disabled,
        type: _vm.type,
        loading: _vm.loading,
        shape: _vm.shape,
        size: _vm.size
      },
      on: { click: _vm.clickHandle }
    },
    [
      _vm.lable
        ? [_vm._v("\n        " + _vm._s(_vm.lable) + "\n    ")]
        : _vm._t("lable")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef55aa94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef55aa94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/button-load.vue
// module id = yGmz
// module chunks = 1